import {useTranslation} from "react-i18next";
import Select from '@mui/material/Select';
import React from 'react';
import {monthNames} from './Trans.js';

function MonthSelect(props) {
	const {t} = useTranslation('obs');
	const {month, monthChange} = props;
	let i, ret = [];

	if (!props.nonone)
		ret.push({id:  0, val: t('stats.none')})

	for (i = 0; i < monthNames.length; i++)
		ret.push({id: i + 1, val: t(monthNames[i])});

	return (<Select native
		    size='small'
		    value={month}
		    onChange={monthChange}
		    sx={props.sx}
		>
			{ret.map((val, i) => {
				return (<option value={val.id} key={val.id}>{val.val}</option>);
			})}
		</Select>
	);
}

export default MonthSelect;
